import { LineaCarritoConPrecio } from '../../types/carrito';
import { TrashIcon, MinusIcon, PlusIcon } from '../shared/icons';
import { validarCantidadDePaquetes } from '../../validation/validators';

interface Props {
  linea: LineaCarritoConPrecio;
  onCambiarCantidad: (cantidad: number) => void;
  onEliminar: () => void;
}

export function CartLineItem({ linea, onCambiarCantidad, onEliminar }: Props) {
  const decrementar = () => {
    const nueva = linea.cantidadDePaquetes - 1;
    if (validarCantidadDePaquetes(nueva) === null) onCambiarCantidad(nueva);
  };
  const incrementar = () => onCambiarCantidad(linea.cantidadDePaquetes + 1);

  return (
    <div
      className="flex flex-wrap items-center gap-4 sm:gap-5 bg-surface border border-border rounded-xl p-4"
      data-testid={`cart-line-item-${linea.id}`}
    >
      <div className="w-[76px] h-[76px] rounded-lg bg-terracotta/20 shrink-0" />
      <div className="flex-1 min-w-[120px] flex flex-col gap-1">
        <div className="text-[15px] font-semibold">Producto</div>
        <div className="text-xs text-ink-muted">S/ {linea.precioUnitarioPaquete.toFixed(2)} c/u</div>
      </div>
      <div className="flex items-center border-[1.5px] border-border rounded-lg shrink-0">
        <button onClick={decrementar} className="px-3 py-2 text-ink-muted" aria-label="Disminuir cantidad">
          <MinusIcon width={14} height={14} />
        </button>
        <span className="px-3.5 py-2 text-[13px] font-semibold border-x border-border">
          {linea.cantidadDePaquetes}
        </span>
        <button onClick={incrementar} className="px-3 py-2 text-ink-muted" aria-label="Aumentar cantidad">
          <PlusIcon width={14} height={14} />
        </button>
      </div>
      <div className="w-20 sm:w-24 text-right text-[15px] font-bold shrink-0">
        S/ {linea.subtotal.toFixed(2)}
      </div>
      <button
        onClick={onEliminar}
        data-testid={`cart-line-remove-${linea.id}`}
        aria-label="Eliminar del carrito"
        className="text-danger shrink-0"
      >
        <TrashIcon width={17} height={17} />
      </button>
    </div>
  );
}
